import {Injectable} from '@angular/core';
import {OperatorService} from '../api/operator.service';

/*
Extends OperatorService to dynamically set the basePath of the api
 */

@Injectable({
  providedIn: 'root'
})
export class HdIdpOperatorApiService extends OperatorService {

  /**
   *
   * @param path
   */
  setBasePath(path: string) {
    this.basePath = path;
  }

  /**
   *
   */
  getBasePath(): string {
    return this.basePath;
  }
}
